function upscaleArtwork(url, size = "t500x500") {
  if (!url || typeof url !== "string") return "";
  return url.replace(/-large\./, `-${size}.`);
}

function parseDurationLabel(value) {
  if (!value || typeof value !== "string") return 0;
  const parts = value.split(":").map((part) => Number(part));
  if (!parts.length || parts.some((part) => Number.isNaN(part))) return 0;

  if (parts.length === 2) {
    return parts[0] * 60 + parts[1];
  }

  if (parts.length === 3) {
    return parts[0] * 3600 + parts[1] * 60 + parts[2];
  }

  return 0;
}

function normalizeDurationMs(trackLike) {
  const raw = trackLike?.model || trackLike;

  if (Number.isFinite(Number(raw?.duration)) && Number(raw.duration) > 0) {
    return Number(raw.duration);
  }

  if (Number.isFinite(Number(trackLike?.duration)) && Number(trackLike.duration) > 1000) {
    return Number(trackLike.duration);
  }

  const secondsFromLabel = parseDurationLabel(trackLike?.duration);
  return secondsFromLabel > 0 ? secondsFromLabel * 1000 : 0;
}

function normalizeArtist(trackLike, rawTrack) {
  return (
    trackLike?.artist ||
    rawTrack?.user?.username ||
    rawTrack?.publisher_metadata?.artist ||
    "Unknown Artist"
  );
}

function normalizeImage(trackLike, rawTrack) {
  return (
    trackLike?.image ||
    upscaleArtwork(rawTrack?.artwork_url) ||
    upscaleArtwork(rawTrack?.user?.avatar_url) ||
    ""
  );
}

export function normalizePlayableTrack(trackLike = {}) {
  const rawTrack = trackLike?.model || trackLike;
  const id = Number(rawTrack?.id || trackLike?.id);

  return {
    id: Number.isInteger(id) ? id : 0,
    title: trackLike?.title || rawTrack?.title || "Untitled",
    artist: normalizeArtist(trackLike, rawTrack),
    image: normalizeImage(trackLike, rawTrack),
    durationMs: normalizeDurationMs(trackLike),
    isUnavailable: Boolean(trackLike?.isUnavailable),
    unavailableText: String(trackLike?.unavailableText || ""),
    rawTrack,
  };
}

export function normalizePlayableQueue(items = []) {
  return items
    .map((item) => normalizePlayableTrack(item))
    .filter((item) => Number.isInteger(item.id) && item.id > 0);
}
